import {Component} from '@angular/core';
import {AppBaseComponent} from '@bbndev/ngx-bbn-zvendo';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent extends AppBaseComponent {
  language = {};
}
